/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Location status
 */
export type LocationStatus = (typeof LocationStatus)[keyof typeof LocationStatus];

export const LocationStatus = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  DEACTIVATED: 'deactivated',
  ARCHIVED: 'archived',
} as const;
